export const locale = {
    lang: 'it',
    data: {
        'NOT_FOUND': {
            'TITLE': 'Pagina non trovata.'
        }
    }
};
